import { Component, Input, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import type { EditionDto, MagazineDto } from '../../api/responses'
import { EditorialBoardComponent } from '../editorial-board/editorial-board.component'

@Component({
  selector: 'dhp-details-header',
  templateUrl: './details-header.component.html',
  styleUrls: ['./details-header.component.scss'],
  imports: [EditorialBoardComponent, TranslatePipe],
})
export class DetailsHeaderComponent {
  readonly magazine = input.required<MagazineDto>()
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() subtitle?: string
  readonly imageAlt = input<string>('details.header.imageAlt')
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() edition: EditionDto | null | undefined
}
